/**
 * @generated SignedSource<<f9cd94c22a26fa4f247b7cbad91e602a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type libraryQuery$variables = {
  count: number;
  cursor?: string | null;
  lang: string;
  langNative: string;
  search?: string | null;
  sort?: string | null;
};
export type libraryQuery$data = {
  readonly articles: {
    readonly " $fragmentSpreads": FragmentRefs<"libraryQuery_Public">;
  };
  readonly courses: {
    readonly " $fragmentSpreads": FragmentRefs<"libraryQuery_Public">;
  };
  readonly lastVisited: {
    readonly " $fragmentSpreads": FragmentRefs<"libraryQuery_Public">;
  };
  readonly mine: {
    readonly " $fragmentSpreads": FragmentRefs<"libraryQuery_Public">;
  };
  readonly public: {
    readonly librarySeo: {
      readonly description: string;
      readonly keywords: ReadonlyArray<string>;
      readonly title: string;
    };
  };
  readonly sets: {
    readonly " $fragmentSpreads": FragmentRefs<"libraryQuery_Public">;
  };
  readonly videos: {
    readonly " $fragmentSpreads": FragmentRefs<"libraryQuery_Public">;
  };
};
export type libraryQuery = {
  response: libraryQuery$data;
  variables: libraryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "langNative"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v6 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v7 = {
  "kind": "Variable",
  "name": "langNative",
  "variableName": "langNative"
},
v8 = {
  "alias": null,
  "args": [
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "concreteType": "LibrarySeo",
  "kind": "LinkedField",
  "name": "librarySeo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "keywords",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "lastVisited",
  "value": true
},
v10 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v11 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "sort"
},
v12 = {
  "kind": "Variable",
  "name": "count",
  "variableName": "count"
},
v13 = {
  "kind": "Variable",
  "name": "cursor",
  "variableName": "cursor"
},
v14 = {
  "kind": "Literal",
  "name": "mine",
  "value": true
},
v15 = {
  "kind": "Literal",
  "name": "kind",
  "value": "set"
},
v16 = {
  "kind": "Literal",
  "name": "course",
  "value": true
},
v17 = {
  "kind": "Literal",
  "name": "kind",
  "value": "article"
},
v18 = {
  "kind": "Literal",
  "name": "kind",
  "value": "video"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 16
  },
  (v6/*: any*/),
  (v7/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "course",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "private",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mine",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoDuration",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textLength",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "top",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avgRating",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authorApiName",
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Rating",
  "kind": "LinkedField",
  "name": "rating",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "continueFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dismissed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finished",
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "SCounts",
  "kind": "LinkedField",
  "name": "counts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theories",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentTestType",
  "kind": "LinkedField",
  "name": "contentTest",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentTestAdminType",
      "kind": "LinkedField",
      "name": "admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "runningSince",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueOff",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accuracy",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SourceEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": [
              (v7/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/)
        ],
        "storageKey": null
      },
      (v37/*: any*/)
    ],
    "storageKey": null
  },
  (v38/*: any*/)
],
v40 = [
  "kind",
  "course",
  "lang",
  "mine",
  "langNative",
  "lastVisited",
  "search",
  "sort"
],
v41 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "cursor"
},
v42 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "count"
},
v43 = [
  (v41/*: any*/),
  (v42/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v14/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v44 = [
  (v41/*: any*/),
  (v42/*: any*/),
  (v15/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v45 = [
  (v41/*: any*/),
  (v16/*: any*/),
  (v42/*: any*/),
  (v15/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v46 = [
  (v41/*: any*/),
  (v42/*: any*/),
  (v17/*: any*/),
  (v6/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v47 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SourceEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/)
        ],
        "storageKey": null
      },
      (v37/*: any*/)
    ],
    "storageKey": null
  },
  (v38/*: any*/)
],
v48 = [
  (v41/*: any*/),
  (v42/*: any*/),
  (v18/*: any*/),
  (v6/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "libraryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "lastVisited",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "count",
                "value": 16
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "libraryQuery_Public"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "mine",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v14/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "libraryQuery_Public"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "sets",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "libraryQuery_Public"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "courses",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v16/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "libraryQuery_Public"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "articles",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v17/*: any*/),
              (v6/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "libraryQuery_Public"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "videos",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v18/*: any*/),
              (v6/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "libraryQuery_Public"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "libraryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "lastVisited",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v20/*: any*/),
            "concreteType": "SourceConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v20/*: any*/),
            "filters": (v40/*: any*/),
            "handle": "connection",
            "key": "Library_sources",
            "kind": "LinkedHandle",
            "name": "sources"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "mine",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v43/*: any*/),
            "concreteType": "SourceConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v43/*: any*/),
            "filters": (v40/*: any*/),
            "handle": "connection",
            "key": "Library_sources",
            "kind": "LinkedHandle",
            "name": "sources"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "sets",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v44/*: any*/),
            "concreteType": "SourceConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v44/*: any*/),
            "filters": (v40/*: any*/),
            "handle": "connection",
            "key": "Library_sources",
            "kind": "LinkedHandle",
            "name": "sources"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "courses",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v45/*: any*/),
            "concreteType": "SourceConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v45/*: any*/),
            "filters": (v40/*: any*/),
            "handle": "connection",
            "key": "Library_sources",
            "kind": "LinkedHandle",
            "name": "sources"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "articles",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v46/*: any*/),
            "concreteType": "SourceConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": (v47/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v46/*: any*/),
            "filters": (v40/*: any*/),
            "handle": "connection",
            "key": "Library_sources",
            "kind": "LinkedHandle",
            "name": "sources"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "videos",
        "args": null,
        "concreteType": "Public",
        "kind": "LinkedField",
        "name": "public",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v48/*: any*/),
            "concreteType": "SourceConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": (v47/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v48/*: any*/),
            "filters": (v40/*: any*/),
            "handle": "connection",
            "key": "Library_sources",
            "kind": "LinkedHandle",
            "name": "sources"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b2b6396f776114ccf778c958ebca71c0",
    "id": null,
    "metadata": {},
    "name": "libraryQuery",
    "operationKind": "query",
    "text": "query libraryQuery(\n  $lang: String!\n  $count: Int!\n  $cursor: String\n  $langNative: String!\n  $search: String\n  $sort: String\n) {\n  public {\n    librarySeo(lang: $lang, langNative: $langNative) {\n      title\n      description\n      keywords\n    }\n    id\n  }\n  lastVisited: public {\n    ...libraryQuery_Public_4Bjt4K\n    id\n  }\n  mine: public {\n    ...libraryQuery_Public_p8ZgG\n    id\n  }\n  sets: public {\n    ...libraryQuery_Public_2NpWWJ\n    id\n  }\n  courses: public {\n    ...libraryQuery_Public_2gpvmz\n    id\n  }\n  articles: public {\n    ...libraryQuery_Public_oZVIX\n    id\n  }\n  videos: public {\n    ...libraryQuery_Public_iJGJI\n    id\n  }\n}\n\nfragment libraryQuery_Public_2NpWWJ on Public {\n  sources(first: $count, after: $cursor, kind: set, lang: $lang, langNative: $langNative, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        uri\n        name(langNative: $langNative)\n        kind\n        course\n        private\n        mine\n        difficulty\n        source\n        videoDuration\n        textLength\n        top\n        avgRating\n        image {\n          url\n          authorName\n          authorApiName\n          id\n        }\n        rating {\n          rating\n          continueFrom\n          picked\n          dismissed\n          finished\n          id\n        }\n        counts {\n          total\n          theories\n        }\n        contentTest {\n          active\n          admin {\n            runningSince\n            revenueOn\n            revenueOff\n            percent\n            accuracy\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment libraryQuery_Public_2gpvmz on Public {\n  sources(first: $count, after: $cursor, kind: set, course: true, lang: $lang, langNative: $langNative, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        uri\n        name(langNative: $langNative)\n        kind\n        course\n        private\n        mine\n        difficulty\n        source\n        videoDuration\n        textLength\n        top\n        avgRating\n        image {\n          url\n          authorName\n          authorApiName\n          id\n        }\n        rating {\n          rating\n          continueFrom\n          picked\n          dismissed\n          finished\n          id\n        }\n        counts {\n          total\n          theories\n        }\n        contentTest {\n          active\n          admin {\n            runningSince\n            revenueOn\n            revenueOff\n            percent\n            accuracy\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment libraryQuery_Public_4Bjt4K on Public {\n  sources(first: 16, lang: $lang, langNative: $langNative, lastVisited: true, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        uri\n        name(langNative: $langNative)\n        kind\n        course\n        private\n        mine\n        difficulty\n        source\n        videoDuration\n        textLength\n        top\n        avgRating\n        image {\n          url\n          authorName\n          authorApiName\n          id\n        }\n        rating {\n          rating\n          continueFrom\n          picked\n          dismissed\n          finished\n          id\n        }\n        counts {\n          total\n          theories\n        }\n        contentTest {\n          active\n          admin {\n            runningSince\n            revenueOn\n            revenueOff\n            percent\n            accuracy\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment libraryQuery_Public_iJGJI on Public {\n  sources(first: $count, after: $cursor, kind: video, lang: $lang, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        uri\n        name\n        kind\n        course\n        private\n        mine\n        difficulty\n        source\n        videoDuration\n        textLength\n        top\n        avgRating\n        image {\n          url\n          authorName\n          authorApiName\n          id\n        }\n        rating {\n          rating\n          continueFrom\n          picked\n          dismissed\n          finished\n          id\n        }\n        counts {\n          total\n          theories\n        }\n        contentTest {\n          active\n          admin {\n            runningSince\n            revenueOn\n            revenueOff\n            percent\n            accuracy\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment libraryQuery_Public_oZVIX on Public {\n  sources(first: $count, after: $cursor, kind: article, lang: $lang, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        uri\n        name\n        kind\n        course\n        private\n        mine\n        difficulty\n        source\n        videoDuration\n        textLength\n        top\n        avgRating\n        image {\n          url\n          authorName\n          authorApiName\n          id\n        }\n        rating {\n          rating\n          continueFrom\n          picked\n          dismissed\n          finished\n          id\n        }\n        counts {\n          total\n          theories\n        }\n        contentTest {\n          active\n          admin {\n            runningSince\n            revenueOn\n            revenueOff\n            percent\n            accuracy\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment libraryQuery_Public_p8ZgG on Public {\n  sources(first: $count, after: $cursor, lang: $lang, mine: true, langNative: $langNative, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        uri\n        name(langNative: $langNative)\n        kind\n        course\n        private\n        mine\n        difficulty\n        source\n        videoDuration\n        textLength\n        top\n        avgRating\n        image {\n          url\n          authorName\n          authorApiName\n          id\n        }\n        rating {\n          rating\n          continueFrom\n          picked\n          dismissed\n          finished\n          id\n        }\n        counts {\n          total\n          theories\n        }\n        contentTest {\n          active\n          admin {\n            runningSince\n            revenueOn\n            revenueOff\n            percent\n            accuracy\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "7270357111b00a26fe1bc07ec0d77869";

export default node;
